import { createAction, props } from '@ngrx/store';

import { ICandidate } from '../interfaces';
import { IFilterParam, IFilterListOption } from '@app/lib/interfaces';
import { IPaginationOptions } from '@app/lib/pagination/interfaces';
import { IResearchStudyDisplay, IResearchSubject } from 'projects/labcorp/clinical-trials-ui/src/lib/interfaces';
import { IResourceStatus } from 'projects/labcorp/clinical-trials-ui/src/lib/types';

export const getOrganizations = createAction(
  '[Candidates] Get Organizations',
);

export const getOrganizationsFailed = createAction(
  '[Candidates] Get Organizations Failed',
);

export const getOrganizationsSuccess = createAction(
  '[Candidates] Get Organizations Success',
  props<{ organizationsData: fhir4.Organization[] }>(),
);

export const selectOrganization = createAction(
  '[Candidates] Select Organization',
  props<{ organization: fhir4.Organization }>(),
);

export const getResearchStudies = createAction(
  '[Candidates] Get Research Studies',
);

export const getResearchStudiesFailed = createAction(
  '[Candidates] Get Research Studies Failed',
);

export const getResearchStudiesSuccess = createAction(
  '[Candidates] Get Research Studies Success',
  props<{ researchStudiesData: IResearchStudyDisplay[] }>(),
);

export const selectResearchStudy = createAction(
  '[Candidates] Select Research Study',
  props<{ researchStudy: IResearchStudyDisplay }>(),
);

export const getCandidates = createAction(
  '[Candidates] Get Candidates',
);

export const getCandidatesFailed = createAction(
  '[Candidates] Get Candidates Failed',
);

export const getCandidatesSuccess = createAction(
  '[Candidates] Get Candidates Success',
  props<{ candidatesData: ICandidate[], paginationOptions: IPaginationOptions, total: number }>(),
);

export const setPageIndex = createAction(
  '[Candidates] Set Page Index',
  props<{ index: number }>(),
);

export const selectCandidate = createAction(
  '[Candidates] Select Candidate',
  props<{ candidate: ICandidate }>(),
);

export const getCriteria = createAction(
  '[Candidates] Get Criteria'
);

export const getCriteriaFailed = createAction(
  '[Candidates] Get Criteria Failed'
);

export const getCriteriaSuccess = createAction(
  '[Candidates] Get Criteria Success',
  props<{ group: fhir4.Group, questionnaireResponse: fhir4.QuestionnaireResponse }>(),
);

export const clearAllSelected = createAction(
  '[Candidates] Clear All Selected Candidates State'
);

export const clearSelectedCandidate = createAction(
  '[Candidates] Clear Selected Candidate'
);

export const updateCandidateDetails = createAction(
  '[Candidates] Update Candidate Details',
  props<{ questionnaireResponseData: fhir4.QuestionnaireResponse, researchSubjectData: IResearchSubject }>(),
);

export const updateCandidateDetailsSuccess = createAction(
  '[Candidates] Update Candidate Details Success',
  props<{ questionnaireResponse: fhir4.QuestionnaireResponse, researchSubject: IResearchSubject }>(),
);

export const updateCandidateDetailsFailed = createAction(
  '[Candidates] Update Candidate Details Failed',
);

export const updateMultipleCandidateProgress = createAction(
  '[Candidates] Update Multiple Candidate Progress',
  props<{ candidates: ICandidate[], statusValue: string }>(),
);

export const updateMultipleCandidateProgressSuccess = createAction(
  '[Candidates] Update Multiple Candidate Progress Success',
  props<{ researchSubjects: IResearchSubject[] }>(),
);

export const updateMultipleCandidateProgressFailed = createAction(
  '[Candidates] Update Multiple Candidate Progress Failed',
);

export const updateResearchSubjectStatus = createAction(
  '[Candidates] Update Research Subject Status',
  props<{ status: IResourceStatus }>(),
);

export const updateResearchSubjectStatusSuccess = createAction(
  '[Candidates] Update Research Subject Status',
);

export const updateResearchSubjectStatusFailed = createAction(
  '[Candidates] Update Research Subject Status',
);

export const updateMultipleResearchSubjectStatus = createAction(
  '[Candidates] Update Multiple Research Subject Statuses',
  props<{ candidates: ICandidate[], status: IResourceStatus }>(),
);

export const updateMultipleResearchSubjectStatusSuccess = createAction(
  '[Candidates] Update Multiple Research Subject Statuses Success',
);

export const updateMultipleResearchSubjectStatusFailed = createAction(
  '[Candidates] Update Multiple Research Subject Statuses Failed',
);

export const exportAllCandidates = createAction(
  '[Candidates] Export All Candidates',
);

export const exportMultipleCandidates = createAction(
  '[Candidates] Export Multiple Candidates',
  props<{ candidates: ICandidate[] }>(),
);

export const updateFilterParams = createAction(
  '[Candidates] Update List Navigator Filter Params',
  props<{ filterParam: IFilterParam }>()
);

export const updateFilterListOptions = createAction(
  '[Candidates] Toggle Filter List Option',
  props<{ filterListOptions: IFilterListOption[] }>()
);

export const updateEligibility = createAction(
  '[Candidates] Update Eligibility',
  props<{ eligible: boolean }>()
);

export const toggleViewArchivedCandidates = createAction(
  '[Candidates] Toggle View Archived Candidates',
);
